import { generateCSSVariablesByTheme } from '@shared/lib/partner'
import { bankirosTheme } from './bankirosTheme'
import { citoraTheme } from './citoraTheme'
import { defaultTheme } from './defaultTheme'
import { defaultWhiteTheme } from './defaultWhiteTheme'
import { globalTradeTheme } from './globalTradeTheme'
import { intervaleTheme } from './intervaleTheme'
import { megafonTheme } from './megafonTheme'
import { platosferaTheme } from './platosferaTheme'
import { smartshellTheme } from './smartshellTheme'
import { vantaTheme } from './vantaTheme'
import { wildberriesTheme } from './wildberriesTheme'

export const defineThemeScript = `
  (function() {
    try {
      var partner = '';

      // Пробуем достать из query
      var match = window.location.search.match(/[?&]partner=([^&]+)/);
      
      if (match) {
        partner = decodeURIComponent(match[1]);
        document.cookie = 'partner=' + partner + '; path=/';
      } else {

        // Пробуем достать из куки
        var cookies = document.cookie.split(';').reduce(function(acc, pair) {
          var parts = pair.trim().split('=');
          acc[parts[0]] = parts[1];
          return acc;
        }, {});
        
        partner = cookies.partner || 'default';
      }
      
      document.documentElement.setAttribute('data-partner', partner);
      
      // создаем объект с доступными темами
      var themes = {
        white: \`
          :root {
            ${generateCSSVariablesByTheme(defaultWhiteTheme)};
          }
        \`,
        megafon: \`
          :root {
            ${generateCSSVariablesByTheme(megafonTheme)};
          }
        \`,
        smartshell: \`
          :root {
            ${generateCSSVariablesByTheme(smartshellTheme)};
          }
        \`,
        globaltrade: \`
          :root {
            ${generateCSSVariablesByTheme(globalTradeTheme)};
          }
        \`,
        intervale: \`
          :root {
            ${generateCSSVariablesByTheme(intervaleTheme)};
          }
        \`,
        citora: \`
          :root {
            ${generateCSSVariablesByTheme(citoraTheme)};
          }
        \`,
        wildberries: \`
          :root {
            ${generateCSSVariablesByTheme(wildberriesTheme)};
          }
        \`,
        wildberries2: \`
          :root {
            ${generateCSSVariablesByTheme(wildberriesTheme)};
          }
        \`,
        vanta: \`
          :root {
            ${generateCSSVariablesByTheme(vantaTheme)};
          }
        \`,
        platosfera: \`
          :root {
            ${generateCSSVariablesByTheme(platosferaTheme)};
          }
        \`,
        bankiros: \`
          :root {
            ${generateCSSVariablesByTheme(bankirosTheme)};
          }
        \`,
        default: \`
          :root {
            ${generateCSSVariablesByTheme(defaultTheme)};
          }
        \`
      };

      var style = document.createElement('style');
      
      // выбираем тему 
      style.innerHTML = themes[partner] || themes.default;
      
      document.head.appendChild(style);
    } catch(e) {}
  })();
`
